import axios from 'axios';
import PathManagement from '../common/path-management';
import { getResponseByUrl, postResponseByUrl } from '../common/xhr';
import { decryptResponse } from '../security/cryptojs-aes-format.js';

export default class HomePageView {

    topCarouselData!: TopCarouselData;
    staticBannersData!: StaticBannersData;
    countdownData!: CountdownData;
    staffPicksData!: StaffPicksData;
    wishlistData!: WishlistData;
    wishlist!: Wishlist;
    deleteWishlist!: DeleteWishlist;
    featuredCardsData!: FeaturedCardsData;
    popularBrandsData!: PopularBrandsData;
    bannerInterior!: BannerInterior;

    async getTopCarouselData(): Promise<TopCarouselData> {
        let _pathManager = new PathManagement();
        let url = _pathManager.getTopCarousel();
        try {
            this.topCarouselData =  await getResponseByUrl(url);
        } catch (err) {
            console.error(err, 'error al intentar recuperar datos de la portada');
        }

        return this.topCarouselData;
    }

    async getFeaturedCardsData(): Promise<FeaturedCardsData> {
        let _pathManager = new PathManagement();
        let url = _pathManager.getFeaturedCardsUrl();
        try {
            this.featuredCardsData =  await getResponseByUrl(url);
        } catch (err) {
            console.error(err, 'error al intentar recuperar datos de la portada');
        }

        return this.featuredCardsData;
    }

    async getPopularBrandsData(): Promise<PopularBrandsData> {
        let _pathManager = new PathManagement();
        let url = _pathManager.getPopularBrandsUrl();
        try {
            this.popularBrandsData =  await getResponseByUrl(url);
        } catch (err) {
            console.error(err, 'error al intentar recuperar datos de la portada');
        }

        return this.popularBrandsData;
    }

    async getStaticBannersData(): Promise<StaticBannersData> {
        let _pathManager = new PathManagement();
        let url = _pathManager.getStaticBannersUrl();
        try {
            this.staticBannersData =  await getResponseByUrl(url);
        } catch (err) {
            console.error(err, 'error al intentar recuperar datos de las provincias');
        }

        return this.staticBannersData;
    }

    async getCountdownData(): Promise<CountdownData> {
        let _pathManager = new PathManagement();
        let url = _pathManager.getCountdownUrl();
        try {
            this.countdownData =  await getResponseByUrl(url);
        } catch (err) {
            console.error(err, 'error al intentar recuperar datos de las provincias');
        }

        return this.countdownData;
    }

    async getStaffPicksData(): Promise<StaffPicksData> {
        let _pathManager = new PathManagement();
        let url = _pathManager.getStaffPicksUrl();
        try {
            this.staffPicksData =  await getResponseByUrl(url);
        } catch (err) {
            console.error(err, 'error al intentar recuperar datos de las provincias');
        }

        return this.staffPicksData;
    }

    async getBannerInterior(type): Promise<BannerInterior> {
        let _pathManager = new PathManagement();
        let url = _pathManager.getBannerInteriorUrl(type);
        try {
            this.bannerInterior =  await getResponseByUrl(url);
        } catch (err) {
            console.error(err, 'error al intentar recuperar datos de banner interior');
        }

        return this.bannerInterior;
    }

    async addToWishlist(artId): Promise<WishlistData> {
        let _pathManager = new PathManagement();
        let url = _pathManager.getWishlistUrl();
        let defaultXhrTimeout = 5000;
        let response = null;
        try {
            // response = await axios.post(
            //     url, { artId }, { withCredentials: true, timeout: defaultXhrTimeout }
            // );

            // // this.wishlistData = decryptResponse(response.data);
            // this.wishlistData = response.data;

            let dataToPost = { artId }
            this.wishlistData = await postResponseByUrl(url, dataToPost)

        } catch (err) {
            console.error(err, 'error al agregar a favoritos');
        }

        return this.wishlistData;
    }


    async getWishlist(): Promise<Wishlist> {
        let _pathManager = new PathManagement();
        let url = _pathManager.getWishlistUrl();
        try {
            this.wishlist =  await getResponseByUrl(url);
        } catch (err) {
            console.error(err, 'error al obtener favoritos');
        }

        return this.wishlist;
    }

    async deleteWishlistItem(artId): Promise<DeleteWishlist> {

        let _pathManager = new PathManagement();
        let url = _pathManager.getWishlistUrl() + "?artId=" + artId;
        let defaultXhrTimeout = 5000;
        let response = null;
        let headers = artId
        try {
            response = await axios.delete(
                url, { withCredentials: true, timeout: defaultXhrTimeout }
            );

            // this.deleteWishlist = decryptResponse(response.data);
            this.deleteWishlist = response.data;
        } catch (err) {
            console.error(err, 'error al borrar de favoritos');
        }
        return this.deleteWishlist;

    }

}

export interface DeleteWishlist {
    deleteWishlist: string;
    artId: string;
}

export interface Wishlist {
    wishlist: string;
}

export interface WishlistData {
    wishListData: string;
}

export interface StaticBannersData {
    staticBannersData: string
}

export interface TopCarouselData {
    topCarouselData: string
}

export interface CountdownData {
    countdownData: string
}

export interface StaffPicksData {
    staffPicksData: string
}

export interface FeaturedCardsData{
    featuredCardsData: string
}

export interface PopularBrandsData{
    popularBrandsData: string
}

export interface BannerInterior{
    bannerInterior: string
}
